import { OrderDirection } from "common/contracts/order-direction";
import PaginationParameters from "common/contracts/pagination-parameters";

export class UserCoworkerFilterParameters {
    name?: string;
    email?: string;
    entityName?: string;


    constructor(
        name?: string,
        email?: string,
        entityName?: string
    ) {
        this.name = name;
        this.email = email;
        this.entityName = entityName;
    }
 
    public asSearchParams(): URLSearchParams {
        const searchParams = new URLSearchParams();
        if (this.name) searchParams.append("name", this.name);
        if (this.email) searchParams.append("email", this.email);
        if (this.entityName) searchParams.append("entityName", this.entityName);
        return searchParams;
    }

    public isEqualTo(other: UserCoworkerFilterParameters): boolean {
        if (!other) return false;
        return this.name === other.name &&
            this.email === other.email &&
            this.entityName === other.entityName;
    }
}

export enum UserCoworkerOrderField {
    Name = "Name",
    Email = "Email",
    EntityName = "EntityName"
}

export class UserCoworkerOrderParameters {
    orderBy?: UserCoworkerOrderField;
    orderDir?: OrderDirection;

    constructor(
        orderBy?: UserCoworkerOrderField,
        orderDir?: OrderDirection
    ) {
        this.orderBy = orderBy;
        this.orderDir = orderDir;
    }

    public asSearchParams(): URLSearchParams {
        const params = new URLSearchParams();
        if (this.orderBy) params.append("orderBy", this.orderBy);
        if (this.orderDir) params.append("orderDir", this.orderDir);
        return params;
    }

    public isEqualTo(other: UserCoworkerOrderParameters): boolean {
        if (!other) return false;
        return this.orderBy === other.orderBy && this.orderDir === other.orderDir;
    }
}


export default class UserCoworkerQuery {
    filterParameters: UserCoworkerFilterParameters;
    orderParameters: UserCoworkerOrderParameters;
    paginationParameters: PaginationParameters;
    query?: string;

    constructor(
        filterParameters: UserCoworkerFilterParameters,
        orderParameters: UserCoworkerOrderParameters,
        paginationParameters: PaginationParameters,
        query?: string
    ) {
        this.paginationParameters = paginationParameters;
        this.orderParameters = orderParameters;
        this.filterParameters = filterParameters;
        this.query = query;
    }

    public asSearchParams(): URLSearchParams {
        return new URLSearchParams([
            ...this.paginationParameters.asSearchParams(),
            ...this.orderParameters.asSearchParams(),
            ...this.filterParameters.asSearchParams(),
            ...(this.query ? [["query", this.query]] : [])
        ]);
    }

    isEqualTo(other: UserCoworkerQuery): boolean {
        if (!other) {
            return false;
        }
        return this.filterParameters.isEqualTo((other.filterParameters)) &&
            this.orderParameters.isEqualTo((other.orderParameters)) &&
            this.paginationParameters.isEqualTo((other.paginationParameters)) &&
            this.query === other.query;
    }
}